<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zmXC96/images/9781250021007.jpg?1724536018052" alt="This image is the cover for the book Pepper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pepper
      </h1>
      <p class="bookDescription body article font2">
        <p>Filled with anecdotes and fascinating information, "a spicy read indeed." (Mark Pendergrast, author of <i>Uncommon Grounds: The History of Coffee and How it Transformed the World</i>)<br/><br/><br/>The perfect companion to Mark Kurlansky's <i>Salt: A World History</i>, <i>Pepper </i>illuminates the rich history of pepper for a popular audience. Vivid and entertaining, it describes the part pepper played in bringing the Europeans, and later the Americans, to Asia and details the fascinating encounters they had there. As Mark Pendergrast, author of <i>Uncommon Grounds, </i>said, "After reading Marjorie Shaffer's <i>Pepper, </i>you'll reconsider the significance of that grinder or shaker on your dining room table. The pursuit of this wizened berry with the bite changed history in ways you've never dreamed, involving extraordinary voyages, international trade, exotic locales, exploitation, brutality, disease, extinctions, and rebellions, and featuring a set of remarkable characters."<br/><br/>From the abundance of wildlife on the islands of the Indian Ocean, which the Europeans used as stepping stones to India and the East Indies, to colorful accounts of the sultan of Banda Aceh entertaining his European visitors with great banquets and elephant fights, this fascinating book reveals the often surprising story behind one of mankind's most common spices.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marjorie Shaffer
      </h2>
      
      <p class="authorDescription body article"><P>MARJORIE SHAFFER has written for <I>The New York Times</I>,<I> The</I><I>Financial Times</I>, and<I> Popular Science</I> magazine. She was a business reporter for <I>Reuters </I>and a former Knight science journalism fellow at the Massachusetts Institute of Technology. A graduate of Brown University, she received a Master of Science degree in biology from the University of Illinois, Urbana-Champaign. She is currently a science writer and editor at New York University School of Medicine. She lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?adbfd244